/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const Star = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <path d="M16.67 20.67a1.83 1.83 0 01-.91-.25L12 18.15l-3.76 2.27a1.72 1.72 0 01-1.31.2 1.76 1.76 0 01-1.3-2.1l1-4.28-3.33-2.88a1.75 1.75 0 011-3.07l4.38-.37 1.71-4a1.76 1.76 0 012.269-.932 1.741 1.741 0 01.951.942l1.71 4 4.38.37a1.75 1.75 0 011 3.07l-3.33 2.88 1 4.28c.106.443.034.91-.2 1.3a1.78 1.78 0 01-1.08.8 2.001 2.001 0 01-.42.04zM12 16.39l4.54 2.74a.23.23 0 00.19 0 .24.24 0 00.15-.11.21.21 0 000-.19l-1.2-5.16 4-3.48a.25.25 0 000-.35.21.21 0 00-.16-.08l-5.28-.45-2.01-4.85a.26.26 0 00-.33-.13.25.25 0 00-.13.14L9.7 9.34l-5.28.45a.19.19 0 00-.16.08.24.24 0 00-.06.19.25.25 0 00.08.17l4 3.47-1.2 5.16a.25.25 0 000 .19.26.26 0 00.16.11.19.19 0 00.18 0L12 16.39z" />,
  );
};

export default Star;
